{
  "conversation": {
    "agent_mode": {
      "saved": "Vald profil",
      "agents": {
        "kaila": {
          "name": "KAILA Jura",
          "description": "Juridisk assistent"
        },
        "kfc": {
          "name": "KAILA Kommune",
          "description": "Denne samtalen er basert på saksbehandlarprofilen. Her blir kommunens opplasta dokument brukt i svaret."
        },
        "replay": {
          "name": "Gjenavspeling",
          "description": "Spel av tidlegare samtalar"
        },
        "mock": {
          "name": "Mock",
          "description": "Simulert agent"
        }
      }
    },
    "ask_kaila_back": {
      "submit_button": "Svar",
      "user_selected": "Eg har valt følgjande moglegheiter:",
      "mode_question": "Spørsmål",
      "mode_suggestion": "Føresetnad",
      "switch_mode": "Utfør djup forsking",
      "keep_previous_mode": "Halde {{previous}}svaret",
      "about_deep": "Djup forsking kan gje deg eit meir utfyllande svar",
      "deep_description": "Djup forsking sjekkar lovgiving, rettspraksis og relaterte kjelder før ein svarar, slik at du kan få meir kontekst og fleire referansar.",
      "kfc_title": "Kva område bør eg fokusere på?",
      "kfc_description": "Eg har identifisert følgjande område som kan vere relevante for spørsmålet ditt. Vel alle relevante alternativ.",
      "skip": "Hoppe over"
    },
    "references_panel": {
      "empty_state": "Ingen kjelder til dette svaret.",
      "source_validation": {
        "button": "Vis",
        "toggle_type": "type",
        "toggle_name": "tittel"
      },
      "error": {
        "title": "Det oppstod ein feil",
        "description": "Det oppstod ein feil under innlasting av kjelder"
      },
      "go_to_document": "Gå til dokument",
      "header": "Kjelder",
      "no_content_disclaimer": "Førehandsvising er ikkje tilgjengeleg",
      "open_in_karnov": "Opna i Lovdata Pro Karnov",
      "ai_generated_summary": {
        "text": "Samandrag frå KAILA",
        "tooltip": "Rettpraksis blir samanfatta av AI for å gi eit raskt overblikk."
      }
    },
    "annotation_type": {
      "karnov": "Karnovs notar",
      "lexino": "",
      "nj_annotation": ""
    },
    "conversation_error": {
      "title": "Noko gjekk gale",
      "description": "Noko gjekk gale med samtalen. Prøv å laste inn sida på nytt eller kontakt kundeservice.",
      "guide": "Hjelp oss å feilsøkje problemet ved å dele innhaldet i samtalen.",
      "send_to_support": "Del samtalen med oss",
      "success_title": "Feilrapport sendt",
      "success_message": "Takk, feilrapporten din er sendt"
    },
    "conversation_feedback": {
      "cancel": "Hopp over",
      "confirmation": "Takk for at du deler tilbakemeldinga di",
      "conversation_rating_question": "Grunngi vurderinga di",
      "description": "Vel den kategorien som passar best til tilbakemeldinga di. Detaljert tilbakemelding gjer det mogleg å forbetre KAILA-svara framover. Når du sender inn tilbakemelding, samtykkjer du til at vi kan sjå tilbakemeldinga di, heile samtalen (spørsmål og svar), eventuelle kjelder og vedlegg.",
      "error": "Noko gjekk gale, prøv gjerne igjen",
      "feedback_modal": "Vi vil gjerne ha tilbakemeldinga di",
      "consent_checkbox": "Eg samtykkjer til å bli kontakta dersom det er behov for ytterlegare opplysningar.",
      "options": {
        "1": {
          "title": "Historiske rettskjelder",
          "placeholder": "Svaret er basert på oppheva rettskjelder"
        },
        "2": {
          "title": "Hallusinasjonar",
          "placeholder": "Svaret inneheld oppdikta referansar eller konklusjonar utan gyldige rettskjelder til å støtte svaret"
        },
        "3": {
          "title": "Manglande rettskjelder",
          "placeholder": "Svaret manglar referansar til relevante rettskjelder. Oppgi gjerne den/de manglande rettskjelda(ne)"
        },
        "4": {
          "title": "Feil bruk av juridisk metode",
          "placeholder": "Feiltolking av rettskjelder"
        },
        "5": {
          "title": "Forelda informasjon",
          "placeholder": "Svaret tok ikkje omsyn til dei nyaste rettskjeldene"
        },
        "6": {
          "title": "Anna",
          "placeholder": "Opplevde du andre problem med svaret? Gi oss beskjed"
        }
      },
      "submit": "Send tilbakemelding",
      "textarea_placeholder": "Utdjup gjerne ...",
      "title": "Takk for at du deler tilbakemeldinga di"
    },
    "conversation_sources": "Kjelder",
    "prompt_templates": {
      "create_title": "Gem ny prompt",
      "create_description": "Gem prompts til senere brug. Det kan være nyttigt til opgaver eller spørgsmål, du ofte gentager eller starter på samme måde.",
      "edit_title": "Rediger prompt",
      "title_label": "Titel",
      "title_placeholder": "",
      "content_label": "Din prompt",
      "content_placeholder": "",
      "save": "Gem",
      "cancel": "Annuller",
      "delete": "Slet",
      "save_success": "Prompt gemt",
      "save_error": "Prompten kunne ikke gemmes",
      "validation_error": "Kontrollér titlen og prompten, og prøv igen",
      "delete_success": "Prompt slettet",
      "delete_error": "Prompten kunne ikke slettes",
      "delete_confirm": {
        "title": "Slet prompt",
        "question": "Er du sikker på, at du vil slette prompten",
        "confirm": "Slet",
        "cancel": "Annullér"
      },
      "title": "Lagra prompts","description": "Ein prompt er spørsmålet du stiller til KAILA. Lagra ofte brukte prompts og gjenbruk dei med ein gong — perfekt for oppgåver og arbeidsflytar du regelmessig kjem tilbake til.","new_prompt": "Ny prompt","search_placeholder": "Søk blant prompts...","search_aria": "Søk blant lagra prompts","search_clear": "Fjern søk","see_details": "Sjå detaljar","close_details": "Gøym detaljar","edit": "Endre","edit_prompt_aria": "Endre prompt: {{title}}","trigger_label": "Prompts","trigger_tooltip": "Opna lagra prompts","no_results": "Ingen resultat","close": "Lukk lagra prompts","delete_prompt_aria": "Slett prompt: {{title}}","error": {"title": "Det oppstod ein feil","description": "Det oppstod ein feil ved lasting av lagra prompts"},
     "pagination": "Sideskifting",
     "pagination_previous": "Førre",
     "pagination_next": "Neste",
     "pagination_previous_aria": "Gå til førre side",
     "pagination_next_aria": "Gå til neste side",
     "pagination_page_aria": "Gå til side {{page}}",
     "attachment_warning": "Opplasting og merkingar er enno ikkje støtta for lagra førespurnader.",
     "suggest": "Foreslå",
     "generating_title": "Generere tittel",
     "title_error": "Klarte ikkje å generere ein tittel."
    },
    "message_done_toast": "Samtalen din er ferdig. Klikk her for å gå til samtalen",
    "message_done_toast_with_subject": "Samtalen din \"{{subject}}\" er ferdig. Klikk her for å gå til samtalen",
    "error": {
      "no_access": {
        "description": "Vel ein annan samtale eller start ein ny samtale i menyen",
        "title": "Du har ikkje tilgang til denne samtalen"
      },
      "not_found": {
        "description": "Vel ein annan samtale eller start ein ny samtale i menyen",
        "title": "Samtale ikkje funnen"
      },
      "unknown": {
        "description": "Prøv å laste inn sida på nytt",
        "title": "Samtalen din kan ikkje hentast for augeblikket"
      }
    },
    "message_action": {
      "cancel_edit_message": "Avbryt redigering",
      "copy_message": "Kopier",
      "delete_failed_user_message": "Slett",
      "downvote_message": "Lik ikkje",
      "upvote_message": "Lik",
      "edit_message": "Rediger prompt",
      "edit": "Rediger",
      "export_docx": "Eksporter til Word",
      "export": "Eksporter",
      "more_actions": "Fleire handlingar",
      "print_message": "Skriv ut",
      "regenerate_message": "Generer svar på nytt",
      "save_message": "Lagre prompt",
      "save": "Lagre",
      "skip_to_content": "Gå til toppen av meldinga",
      "to_top": "Til toppen"
    },
    "export_docx": {
      "success": "Dokument eksportert",
      "error": "Klarte ikkje å eksportere dokument",
      "question_heading": "Spørsmål",
      "answer_heading": "Svar"
    },
    "prompt_input": {
      "disclaimer_text": "AI-en vår bruker kjelder frå Karnov-databasen, men kan gjere feil. Dobbeltsjekk derfor viktige opplysningar.",
      "disclaimer_link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "placeholder": "Skriv spørsmålet ditt",
      "placeholder_follow_up": "Skriv eit oppfølgingsspørsmål",
      "document_tag": "Vis til dokument"
    },
    "document_tagging": {
      "placeholder": "Skriv dokumentnamnet her",
      "prompt_input_suggestion": "Vis til dokument",
      "clear_input": "Tøm søkjetekst",
      "finding_documents": "Hentar dokument ...",
      "search_for_documents_title": "Søk etter eit dokument frå Lovdata Pro Karnov",
      "search_for_documents_description": "Oppgi dokumenttittel eller referansenummer",
      "no_documents_found_title": "Fann ingen dokument",
      "no_documents_found_description": "Skriv ein gyldig tittel eller referanse, eller gå til Lovdata Pro Karnov og finn dokumentet.",
      "kfc_disclaimer": "Kaila har alt tilgang til dine lokale dokument, så dei treng ikkje å taggast.",
      "error_title": "Noko gjekk gale",
      "error_description": "Prøv å laste inn sida på nytt",
      "title": "Søkjeresultat"
    },
    "prompt_button": {
      "label": "Spør Kaila",
      "stop": "Avbryt"
    },
    "research_mode": {
      "light": {
        "name": "Lett forsking",
        "short": "Lett",
        "description": "For raske spørsmål. Hentar eit lett sett av kjelder, ikkje full forskingsgjennomgang."
      },
      "regular": {
        "name": "Vanleg forsking",
        "short": "Vanleg",
        "description": "Søkjer gjennom alle Karnov-kjelder i full og byggjer eit strukturert svar."
      },
      "deep": {
        "name": "Djup forsking",
        "short": "Djup",
        "description": "Køyrer ein grundig søk for komplekse spørsmål. Tek lengre tid."
      }
    },
    "user_message": {
      "cancel_button": "Avbryt",
      "submit_button": "Lagre og send"
    },
    "table_view": {
      "close_button": "Lukk tabell i full storleik",
      "modal_title": "Tabell i full storleik",
      "open_button": "Opna i full storleik"
    },
    "loading_header": {
      "estimated_time": "Estimert ventetid",
      "less_than_a_minute": "Mindre enn eitt minutt",
      "minutes_one": "{{count}} minutt",
      "minutes_other": "{{count}} minutt",
      "slow_answer_disclaimer": "Genererer eit komplekst svar. Dette kan ta litt ekstra tid."
    },
    "clipboard": {
      "copy_success": "Innhald kopiert",
      "copy_error": "Kopiering av innhald mislukkast"
    }
  },
  "conversation_history": {
    "load_more_button": "Last inn fleire",
    "load_more_title": "Viser side {{currentPage}} av {{totalPages}}",
    "no_more_conversations": "Du har nådd slutten av samtalehistorikken din.",
    "go_to_top": "Gå til toppen av lista",
    "close_conversation_history_panel": "Skjul historikk",
    "close_conversation_sidepanel": "Lukk sidepanel",
    "conversation_expiration_one": "{{count}} dag",
    "conversation_expiration_other": "{{count}} dagar",
    "conversation_expiration_tooltip_one": "Utløper om 1 dag. Fest eller send ei ny melding for å behalde samtalene dine.",
    "conversation_expiration_tooltip_other": "Utløper om {{count}} dagar. Fest eller send ei ny melding for å behalde samtalene dine.",
    "conversation_expiration_expired_tooltip": "Samtalene dine blir lagra i 90 dagar etter siste aktivitet. Deretter blir dei automatisk sletta.",
    "conversation_action": {
      "delete": "Slett samtale",
      "pin": "Fest",
      "rename": "Gi nytt namn",
      "unpin": "Fjern festing"
    },
    "conversation_delete_modal": {
      "cancel_button": "Avbryt",
      "delete_button": "Slett",
      "title": "Slett samtale",
      "question": "Er du sikker på at du vil slette samtalen"
    },
    "error": {
      "description": "Prøv å laste inn sida på nytt",
      "title": "Historikken din kan ikkje hentast for augeblikket"
    },
    "expired_conversations_onboarding": "For å verne om dataene dine vil samtalar som har vore inaktive i meir enn 90 dagar no bli permanent sletta.",
    "history": "Historikk",
    "history_expiration_time": "90 dagar",
    "history_short": "Historikk",
    "history_tooltip": "Samtalene dine blir lagra i 90 dagar etter siste aktivitet. Deretter blir dei automatisk sletta.",
    "new_conversation_button": "Ny samtale",
    "new_conversation_button_short": "Ny",
    "new_conversation_subject": "Ny samtale",
    "new_document_analysis_button": "KAILA Dokumentanalyse",
    "new_document_analysis_button_beta_label": "BETA",
    "new_document_analysis_button_new_label": "Nyheit",
    "new_document_analysis_button_short": "Analyse",
    "flow_access_link": "KAILA Flow",
    "flow_access_link_short": "Flow",
    "open_conversation_history_panel": "Vis historikk",
    "open_conversation_sidepanel": "Opna sidepanel",
    "panel_header": "Meny",
    "pinned": "Festa",
    "edit_conversation_subject_submit": "Lagre endringane i samtaleemnet",
    "edit_conversation_subject_cancel": "Avbryt endringane i samtaleemnet",
    "search_in_conversation": "Finn samtale",
    "search_in_conversation_description": "Søk i samtalar etter emne",
    "search_in_conversation_clear": "Tøm søk",
    "empty_search_in_conversation": "Ingen samtalar vart funne med søket: \"{{searchTerm}}\"",
    "toast_notification": {
      "conversation_pinned_error": "Festing av samtale mislukkast",
      "conversation_unpinned_error": "Fjerning av festing mislukkast",
      "conversation_pinned_successful": "Samtale festa",
      "conversation_unpinned_successful": "Samtale ikkje lenger festa",
      "conversation_delete_success": "Samtale sletta",
      "conversation_delete_error": "Samtalen vart ikkje sletta",
      "subject_editting_error": "Endringar kunne ikkje gjennomførast",
      "subject_editting_sucessful": "Endringar gjennomført"
    },
    "today": "I dag",
    "yesterday": "I går",
    "latest_7_days": "Siste 7 dagar",
    "latest_15_days": "Siste 15 dagar",
    "latest_30_days": "Siste 30 dagar",
    "latest_60_days": "Siste 60 dagar",
    "more_than_60_days": "Over 60 dagar – utløper snart",
    "expired": "Utløper snart",
    "retention_info": "Dei aktive samtalene dine blir lagra i 90 dagar. Deretter blir dei automatisk sletta for å verne om personvernet ditt."
  },
  "file_upload": {
    "capacity_usage": "{{space}}% plass brukt",
    "content_type": {
      "application/pdf": "PDF",
      "application/msword": "Word",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
      "unknown": "Ukjend",
      "unsupported": "Filtype ikkje støtta"
    },
    "drag_and_drop_label_one": "Dra og slepp dokumentet ditt her",
    "drag_and_drop_label_other": "Dra og slepp dokumenta dine her",
    "file_upload_limit_exceeded": "Du har valt for mange filer.",
    "file_upload_limit_reached": "Du kan ikkje laste opp fleire dokument.",
    "header": "Last opp dokumentet ditt for å kome i gang",
    "subheader": "Kan vere Word (.docx) eller PDF",
    "upload_button": "Last opp dokument",
    "upload_status": {
      "error": "Feil",
      "uploading": "Lastar opp",
      "deleting": "Slettar"
    },
    "error": {
      "above_page_count_limit": "Filene kan ikkje innehalde meir enn 400 sider.",
      "above_word_count_limit": "Filene kan ikkje innehalde meir enn 100 000 ord",
      "above_file_size_limit": "Filene kan ikkje vere større enn 20 MB.",
      "content_too_large": "Filene kan ikkje vere større enn 20 MB.",
      "malformed_file_content": "Fila kunne ikkje lesast – ho ser ut til å vere skada",
      "deletion_error": "Det oppstod ein feil under sletting av fila.",
      "invalid_mime_type": "Du kan berre laste opp Word- (.docx) og PDF-filer.",
      "exceeds_token_limit": "Dette dokumentet overskriv plassgrensa og vil ikkje bli brukt.",
      "upload_error": "Det oppstod ein feil under opplasting.",
      "virus_detected": "Den opplasta fila ser ut til å innehalde eit virus."
    }
  },
  "frequently_asked_questions": {
    "footer": {
      "customer_service": "Kundeservice",
      "customer_service_url": "https://www.karnovgroup.dk/om-os/kontakt",
      "terms": "Brukarvilkår",
      "terms_url": "https://pro.karnovgroup.dk/tos_acceptance"
    },
    "help": "Hjelp",
    "helpful_question_answer_title": "Svarte dette på spørsmålet ditt?",
    "helpful_question_answer_button_yes": "Ja",
    "helpful_question_answer_button_no": "Nei",
    "thank_you_for_feedback_description": "Innspela dine hjelper til med å forbetre denne informasjonen for alle.",
    "thank_you_for_feedback_title": "Takk for tilbakemeldinga!",
    "thank_you_for_feedback_toast_notification": "Takk for tilbakemeldinga",
    "related_questions": "Relaterte spørsmål"
  },
  "help_and_feedback": {
    "button": "Hjelp og tilbakemelding",
    "dropdown_options": {
      "help": "Hjelp",
      "tutorial": "Vegleiing",
      "user_carousel_onboarding": "Onboarding"
    }
  },
  "kfc": {
    "description": "Det første svaret er basert på kjelder i Karnov-databasen, medan dette supplerande svaret byggjer på kommunens interne dokument, under føresetnad av at desse er lasta opp og tilgjengelege i Karnov Kommune. Begge svar inkluderer referansar og lenkjer til kjeldene dei byggjer på."
  },
  "message": {
    "create_conversation_message_error": "Klarte ikkje å sende.",
    "create_conversation_message_retry": "Prøv igjen",
    "streaming_waiting": "Avventar svar",
    "streaming_canceled": "Svar stoppa",
    "streaming_error": "Det oppstod ein feil under generering av svaret",
    "streaming_error_retry": "Generer igjen",
    "streaming_error_code": "Feilkode",
    "streaming_error_conversation": "Samtale",
    "streaming_reconnect_error": "Det oppstod ein feil under forsøk på å gjenopprette tilkoplinga",
    "streaming_reconnect_error_retry": "Forsøk å gjenopprette tilkoplinga",
    "thoughts": "Refleksjonar",
    "follow_up": "Du kan òg spørje",
    "follow_up_description": "Forslaga til oppfølgingsprompt hjelper deg vidare i samtalen. Du kan velje eitt av forslaga og tilpasse det til din konkrete situasjon ved å gi meir kontekst, styre eller utvide samtalen.",
    "updated_at": "{{updatedAt, date}}"
  },
  "no_access": {
    "title": "Du har ikkje tilgang til dette innhaldet",
    "description": "Dette innhaldet krev tilgang til eit produkt som ikkje er inkludert i det noverande abonnementet ditt.",
    "refresh_access": {
      "button": "Oppdater tilgang",
      "description": "Om du meiner at det er ein feil, kan du prøve å oppdatere tilgangsinnstillingane dine – det vil synkronisere abonnementet ditt og låse opp det innhaldet du har tilgang til.",
      "contact_support": "Om problemet held fram, blir du beden om å kontakte kundeservice."
    },
    "contact_info": {
      "header": "Vi er klare til å hjelpe",
      "description": "Ring eller skriv til kundeservice vår og høyr om ulike lisensar",
      "link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "phone": "+45 33 74 07 00",
      "email": "kundeservice@karnovgroup.com"
    }
  },
  "system_messages": {
    "_ANALYSING_DOCUMENTS_": "Analyserer dokument",
    "_ANALYSING_QUERY_": "Analyserer spørsmålet",
    "_ANALYSING_SOURCES_": "Analyserer kjelder",
    "_FETCHING_SIMILAR_DOCUMENTS_": "Søkjer etter kjelder",
    "_FETCHING_LAW_DOCUMENTS_": "Søkjer etter lovreferansar",
    "_FETCHING_PREPATORY_WORK_DOCUMENTS_": "Søkjer etter førearbeid",
    "_FETCHING_LITERATURE_DOCUMENTS_": "Søkjer etter litteraturreferansar",
    "_GENERATING_ANSWER_": "Genererer eit svar"
  },
  "document_tag_tooltip": "Klikk eller skriv ”@” for å vise til eit dokument",
  "input_character_limit_reached": "Maksimalt tal teikn er nådd",
  "user_carousels": {
    "dismiss": "Hald fram",
    "carousels": {
      "onboarding": {
        "title": "Velkomen til KAILA",
        "read_more_url": "",
        "screens": {
          "welcome": {
            "description": "Kombinasjonen av kvardagsspråk og Karnovs AI-modell gjer det enklare å søkje etter juridisk informasjon",
            "header": "Finn svar på dei juridiske spørsmåla dine"
          },
          "credibility": {
            "description": "Den menneskelege kunnskapen forsterkar AI-teknologien, og du vil alltid ha det siste ordet",
            "header": "Basert på innhaldet til Karnov"
          },
          "security": {
            "description": "KAILA sikrar dataene dine gjennom streng datastyring",
            "header": "Dataene dine blir tekne godt vare på"
          },
          "feedback": {
            "description": "Vurder dei genererte svara og fortel oss kva vi kan forbetre",
            "header": "Hjelp oss å forbetre KAILA med tilbakemeldingane dine"
          }
        }
      }
    },
    "read_more_label": "Les meir"
  },
  "header": {
    "goto_main_content": "Gå til innhaldet"
  },
  "user_menu": {
    "logout": "Logg ut",
    "go_to_platform": "Lovdata Pro Karnov",
    "redirect_to_login": "Oppdater tilgang",
    "theme_selector": {
      "appearance": "Utsjånad",
      "theme": {
        "dark": "Mørk",
        "light": "Lys",
        "system": "System"
      }
    },
    "language_selector": {
      "content": "innhald",
      "header": "Språk",
      "languages": {
        "da": "Dansk",
        "es": "Spansk",
        "fr": "Fransk",
        "sv": "Svensk",
        "no": "Bokmål",
        "nn": "Nynorsk"
      }
    },
    "go_to_flow": "KAILA Flow",
    "learn_about_flow": "Lær meir om den nye løysinga vår",
    "badge": "Nyheit"
  },
  "platform_name": "KAILA",
  "document_analysis": {
    "select_document_analysis_mode": "Vel ei analysemoglegheit",
    "hero_banner": {
      "intro": "Karnov introduserer",
      "headline": "KAILA dokumentanalyse",
      "description": "Ekspertane våre har utvikla unike analysemoglegheiter som hjelper deg med å omsetje komplisert juss til konkrete løysingar."
    },
    "file_upload_header": {
      "description": "Last opp kontrakten din for å kome i gang",
      "title": "Kontraktsgjennomgang"
    },
    "use_prompt_button": "Vel analyse",
    "see_example_button": "Sjå eksempel",
    "back_to_document_analysis_list": "Tilbake til dokumentanalysar",
    "options": {
      "contract_review": {
        "title": "Analyser kontraktar",
        "description": "Få ei rask, klausul-for-klausul gjennomgang av kontrakten din. For kvar klausul hentar KAILA dei viktigaste kjeldene, markeringar mogleg risiko, vurderer risikonivå – høgt, middels, lågt – og foreslår konkrete forbetringar. Du får ei oversiktleg vurdering av heile kontrakten, med klare anbefalingar og dokumenterte kjelder.",
        "guide": "I tillegg til det opplasta dokumentet kan du leggje til supplerande opplysningar, til dømes kontraktstype og part, samt andre relevante omstende som ikkje går fram av dokumentet.",
        "example_text": "Her ser du eit eksempel på ein analyse. Det gir overblikk over KAILA-svara, slik at du kan vurdere om det passar til behova dine.",
        "placeholder": "Legg til supplerande opplysningar"
      },
      "document_compliance": {
        "title": "Analyser compliance-politikk",
        "description": "Analyser og samanlikn compliance-politikken din med relevante rettskjelder. KAILA leverer ein rapport i tre delar: eit kort samandrag, ein oversiktstabell med risikovurdering og ei liste med tydelege løysingsforslag. Du får eit komplett overblikk, slik at du veit kva neste steg er.",
        "guide": "I tillegg til det opplasta dokumentet kan du leggje til supplerande opplysningar, til dømes kva part du er, eller andre relevante omstende som ikkje går fram av dokumentet.",
        "example_text": "",
        "placeholder": "Legg til supplerande opplysningar"
      },
      "argument_strengthener": {
        "title": "Styrk argument",
        "description": "Få ei rask gjennomgang av argumenta dine. KAILA går gjennom argumenta dine, samanliknar dei med relevante rettskjelder og finn svakheitene i argumentasjonen. Du får sterkare argument som er veldokumenterte med nøyaktige referansar til innhaldet til Karnov.",
        "guide": "I tillegg til det opplasta dokumentet kan du leggje til supplerande opplysningar, til dømes kva part du er, eller andre relevante omstende som ikkje går fram av dokumentet.",
        "example_text": "",
        "placeholder": "Legg til supplerande opplysningar"
      },
      "weakness_finder": {
        "title": "Finn svakheiter",
        "description": "Finn dei stadene der argumentasjonen er svak eller mangelfull. KAILA går gjennom motparten sine argument og kjem med motargument, foreslår mogleg angrepsvinklar og hjelper med å formulere dei beste argumenta med konkrete kjeldevisingar. Du får ein strategi for å utnytte svakheitene til motparten – dokumentert og klar til bruk.",
        "guide": "I tillegg til det opplasta dokumentet kan du leggje til supplerande opplysningar, til dømes kva part du er, eller andre relevante omstende som ikkje går fram av dokumentet.",
        "example_text": "",
        "placeholder": "Legg til supplerande opplysningar"
      }
    }
  },
  "workspace_promo_banner": {
    "text": "Kom i gang med KAILA Flow",
    "link": "Les meir",
    "badge": "Nyheit"
  },
  "prompt_suggestions": {
    "kaila": {
      "title": "Finn svar til det juridiske informasjonsbehovet ditt",
      "description": "La deg inspirere av desse forslaga",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Eg treng ein oversikt over forskjellen på reglane om innsyn etter offentleglova og forvaltningslova. Eg vil ha det som ein tabell.",
          "sample": "Eg treng ein oversikt over forskjellen på reglane om innsyn etter offentleglova og forvaltningslova."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Eg treng dei beste argumenta for at klienten min kan få lågast mogleg straff for å ha bore kniv på gata. Klienten min vart stoppa av politiet i ein rutinekontroll. Det var snakk om ein kniv som normalt blir brukt i arbeid. Klienten min vart stoppa ein tysdag føremiddag. Det skjedde i ei sterkt trafikkert gate i sentrum av ein by.",
          "sample": "Eg treng inspirasjon til argument som skal sikre at klienten min får lågast mogleg straff."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Korleis skal vesentlegheitskravet i næringsleigelova § 13 tolkast?",
          "sample": "Eg treng ei utgreiing for vesentlegheitskravet i næringsleigelova § 13."
        },
        {
          "category": "book-section",
          "prompt": "Eg treng eit utkast til klage til ein kommune i samband med avslag på tilskot til talepedagog til eit barn. Barnet er tre år og har nedsett høyrsel, den eine av foreldra er utan arbeid og den andre forelderen er ikkje ein del av livet til barnet. Inkluder relevant lovgjeving i utkastet.",
          "sample": "Eg treng eit framlegg til klage i samband med avslag på tilskot til talepedagog til eit mindreårig barn."
        }
      ]
    },
    "kfc": {
      "title": "Finn svar på tvers av lovgjeving og kommunen sine eigne dokument",
      "description": "La deg inspirere av desse forslaga",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Kan ein mottakar av økonomisk sosialhjelp som oppfyller vilkåra for ferie først ta ut 14 dagars ferie med ytelse og deretter 14 dagar utan ytelse?",
          "sample": "Kan ein mottakar av økonomisk sosialhjelp som oppfyller vilkåra for ferie først ta ut 14 dagars ferie med ytelse og deretter 14 dagar utan ytelse?"
        },
        {
          "category": "book-section",
          "prompt": "Er tøyeøvingar for å kunne oppretthalde basale funksjonar som påkleding, bad osv. ei ytelse etter helse- og omsorgstenestelova § 3-2 eller § 3-3?",
          "sample": "Er tøyeøvingar for å kunne oppretthalde basale funksjonar som påkleding, bad osv. ei ytelse etter helse- og omsorgstenestelova § 3-2 eller § 3-3?"
        },
        {
          "category": "book-section",
          "prompt": "Kva forhold skal kommunen vere særleg merksam på i avgjerda si om nedlegging av ein privat fellesveg?",
          "sample": "Kva forhold skal kommunen vere særleg merksam på i avgjerda si om nedlegging av ein privat fellesveg?"
        },
        {
          "category": "book-section",
          "prompt": "Kva krav til behandling av personopplysningar finst ved manuell vidareformidling av opplysningar om enkeltpersonar frå ein kommune til ein annan forvaltningsmyndigheit?",
          "sample": "Kva krav til behandling av personopplysningar finst ved manuell vidareformidling av opplysningar om enkeltpersonar frå ein kommune til ein annan forvaltningsmyndigheit?"
        }
      ]
    },
    "replay": {
      "title": "Spel av tidlegare samtalar som er lagra lokalt på eininga di",
      "description": "Skriv indeksen til ein tidlegare samtale du vil spele av.",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "example",
          "sample": "Example"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "error",
          "sample": "Error"
        }
      ]
    },
    "mock": {
      "title": "Test rendering av ulike prompt",
      "description": "Test ulike brukstilfelle med desse eksempla",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "test",
          "sample": "test"
        },
        {
          "category": "book-section",
          "prompt": "gfm",
          "sample": "Git flavoured markdown"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "invalid",
          "sample": "Invalid response"
        },
        {
          "category": "book-section",
          "prompt": "markdown",
          "sample": "markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-malformed",
          "sample": "Invalid & malformed markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-error",
          "sample": "Component that throws an uncaught exception"
        },
        {
          "category": "table",
          "prompt": "table",
          "sample": "table"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "details",
          "sample": "details"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "stressTest",
          "sample": "stress test"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "markdownAndInlineReferences",
          "sample": "Inline references after markdown elements"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "refsList",
          "sample": "Inline references in list"
        },
        {
          "category": "book-section",
          "prompt": "new-refsList",
          "sample": "New reference mdx format"
        }
      ]
    }
  },
  "errors": {
    "footer": {
      "title": "Vi er klare til å hjelpe",
      "description": "Om du har støytt på problem, kontakt kundeservice på {{telephone}} eller {{email}}",
      "email": "kundeservice@karnovgroup.com",
      "telephone": "33 74 07 00"
    },
    "auth": {
      "no_session": {
        "title": "",
        "subtitle": "",
        "description": ""
      },
      "default": {
        "title": "Vi klarte ikkje å logge deg inn",
        "subtitle": "",
        "description": "Det oppstod ein feil under innlogging. Prøv igjen, eller kontakt kundesupport dersom problemet held fram."
      }
    }
  },
  "close_service_message_banner": "Lukk melding",
  "upload_modal": {
    "attachment_limit_exceeded_warning": "Du har valt for mange dokument. Du kan leggja ved opptil {{attachmentLimit}} dokument, avhengig av storleiken på dokumenta.",
    "close_modal_button_label": "Fullfør",
    "description": "Du kan leggja ved opptil 10 dokument, avhengig av storleiken på dokumenta.",
    "done_button": "Fullfør",
    "file_browser": {
      "browse_files": "Bla gjennom",
      "description": "Støtta format: .pdf, .docx",
      "header": "Klikk for å lasta opp dokument"
    },
    "capacity_indicator": {
      "attachment_count": "{{count}}/{{limit}} dokument",
      "tooltip": "Kvart dokument tek opp ein prosentdel av den totale opplastingsgrensa di, basert på talet på ord – ikkje filstorleik. Lange dokument fyller difor meir, slik at du kan nå 100 % før du har lasta opp 10 filer.",
      "used_capacity": "brukt plass"
    },
    "file_upload_button_tooltip": "Last opp filer",
    "header": "Last opp filer",
    "open_modal_button": "Last opp filer",
    "onboarding_tooltip": "Nyheit: Du kan no lasta opp opptil 10 dokument per melding.",
    "reinsurance_label": "Filene dine er krypterte",
    "reinsurance_tooltip": "Karnov Group vernar konfidensialiteten til alle kundedata, inkludert brukarinndata, genererte data og dokument, ved hjelp av sterk kryptering som oppfyller gjeldande standardar."
  },
  "prompt_input_with_document_references": {
    "add_document_references_button": {
      "label": "Vis til dokument",
      "tooltip": "Klikk for å vise til eit dokument",
      "onboarding_tooltip": "Vi har gjort det enklare å vise til dokument."
    }
  },
  "document_references_modal": {
    "description": "Ved at henvise til dokumenter fra Karnov kan du få et mere præcist svar",
    "close_modal_button_label": "Fullfør",
    "document_references_count": "Valde dokumentreferansar ({{count}})",
    "done_button": "Fullfør",
    "empty_state": {
      "header": "Ta med ei kjelde i svaret",
      "description": "Du kan bruke denne funksjonen dersom du vil vere sikker på at éi eller fleire kjelder blir tekne med i svaret frå Kaila."
    },
    "header": "Vis til dokument",
    "remove_document_reference_button": "Fjern referanse",
    "search": {
      "fetching_suggestions": "Hentar dokument...",
      "input_label": "Søk etter eit dokument",
      "input_placeholder": "Skriv dokumentnamnet her",
      "error": {
        "description": "Prøv å laste sida på nytt",
        "title": "Noko gjekk gale"
      },
      "empty_search": {
        "description": "Skriv ein gyldig tittel eller referanse, eller gå til Lovdata Pro Karnov og finn dokumentet.",
        "kfc_disclaimer": "Kaila har alt tilgang til dine lokale dokument, så dei treng ikkje å taggast.",
        "title": "Fann ingen dokument"
      }
    }
  },
  "message_resources": {
    "remove_message_resource": {
      "attachment": "Fjern dokument",
      "document_reference": "Fjern tilvising"
    },
    "open_modal": {
    "attachment": "Sjå dokument",
    "document_reference": "Sjå referansar"
    },
    "placeholder": {
      "label": {
        "attachment": "{{count}} opplasta filer",
        "document_reference": "{{count}} dokument det blir vist til"
      },
      "tooltip": {
        "attachment": "Sjå alle opplasta filer",
        "document_reference": "Sjå alle dokumenta det blir vist til"
      }
    }
  },
  "search": {
    "clear_input": "Tøm søketekst",
    "placeholder": "Søkje..."
  }
}
